class Upsell {
  constructor(first_upsell_product) {
    this.first_upsell_product = first_upsell_product;
    this.cart = document.querySelector("side-cart");
    this.upsell_collection = JSON.parse(
      document.querySelector("#upsell_collection_json").textContent
    ).upsell_collection;
    this.cartSettings = JSON.parse(document.querySelector("#cart-drawer-settings").textContent);

    this.render_side_cart_upsell();

  }

  async get_upsell_products_not_in_cart() {
    const response = await fetch('/cart.json');
    const cart = await response.json();

    return this.upsell_collection.filter(
      (product) => !cart.items.some((item) => item.id === product.id)
    );
  }
  
  async render_side_cart_upsell() {
    const recommendedList = document.querySelector(
      ".product-recommendations__list"
    );
    if (!recommendedList) return;

    const _this = this; 

    const response = await fetch('/cart.json');
    const cart = await response.json();

    const upsell_products = await this.get_upsell_products_not_in_cart();
    let product_to_render;

    // check if first product in cart
    // if not add first product; else add random upsell product
    if (
      cart.items.every(
        (product) => product.product_id !== this.first_upsell_product.id
      )
    ) {
      product_to_render = this.first_upsell_product;
    } else {
      const randomInt = this.randomIntFromInterval(
        0,
        upsell_products.length - 1
      );
      product_to_render = upsell_products[randomInt];
    }

    recommendedList.innerHTML = getSideCartUpsellTemplate(product_to_render);

    const addUpsellProductBtn = document.querySelector(
      "#cart-drawer .product-recommendations__list .RecommendedProduct__add-product-btn"
    );

    if (addUpsellProductBtn) {
      addUpsellProductBtn.addEventListener("click", function (e) {
        const variantId =
          e.target
            .closest(".RecommendedProduct__upsell-cta-wrapper")
            .querySelector(".RecommendedProduct__upsell-product-options")
            ?.value || e.target.getAttribute("data-single-variant-id");
        var addData = {
          id: variantId /* for testing, change this to a variant ID on your store */,
          quantity: 1,
        };

        fetch("/cart/add.js", {
          body: JSON.stringify(addData),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With":
              "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
          },
          method: "POST",
        })
          .then((response) => {
            if (_this.cartSettings.use_rebuy_cart) {
              window.Rebuy.SmartCart.show();
            } else {
              _this.cart.renderCart(true);
            }
          })
          .catch(function (err) {
            /* uh oh, we have error. */
            console.error(err);
          });
      });
    }

    function getSideCartUpsellTemplate(product) {
      const optionsTemplate = `
        <select class="RecommendedProduct__upsell-product-options">
          ${product.variants
            .map((variant) => {
              return `<option value='${variant.id}' ${
                variant.available ? "" : "disabled"
              }>${variant.title}</option>`;
            })
            .join("")}
        </select>
      `;

      return `
        <div class="RecommendedProduct">
          <div class="RecommendedProduct__header-wrapper">
            <h5 class="RecommendedProduct__header">Check this out!</h5>
            <span class="RecommendedProduct__subheader">Our customers are loving this...</span>
          </div>
          <div class="RecommendedProduct__info-wrapper">
            <a href=${
              product.url ? product.url : `/products/${product.handle}`
            } class="RecommendedProduct__anchor">
              <img class="RecommendedProduct__img" src=${
                product.featured_image
                  ? product.featured_image
                  : product.images[0].src
              } alt=${product.title}/>
            </a>
            <div class="RecommendedProduct__info">
              <p class="RecommendedProduct__title">${product.title}</p>
              <p class="RecommendedProduct__price">${
                product.price
                  ? `$${parseFloat(product.price / 100).toFixed(2)}`
                  : "$" + product.variants[0].price
              }</p>
            </div>
          </div>
          <div class="RecommendedProduct__upsell-cta-wrapper">
            ${product.variants.length > 1 ? optionsTemplate : ""}
            <button ${
              product.variants.length === 1
                ? `data-single-variant-id=${product.variants[0].id}`
                : ""
            } class="RecommendedProduct__add-product-btn button button--full-width">Add To Cart</button>
          </div>
        </div>
      `;
    }
  }

  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
}

class PopupUpsell extends Upsell {
  constructor(first_upsell_product) {
    super(first_upsell_product);
    
    this.popup = document.querySelector("#upsell-popup");

    this.render_upsell_popup();

    document
      .querySelectorAll(".upsell-close, .upsell-continue")
      .forEach((btn) =>
        btn.addEventListener("click", this.continue_to_sidecart.bind(this))
      );
  
    document.addEventListener("click", (event) => {
      if (event.target.closest(".upsell-content button")) {
        this.add_popup_upsell(event);
      }
    });
  }

  toggle_upsell_popup() {
    if (this.popup) {
      this.popup.classList.toggle("active");

      if (this.popup.classList.contains("active")) {
        // allow the CSS animation to finish
        setTimeout(() => {
          trapFocus(
            this.popup,
            this.popup.querySelector(".upsell-close")
          );
        }, 350);
      }
    }
  }

  continue_to_sidecart() {
    const button = document.querySelector("product-form form button");
    this.toggle_upsell_popup();
    button.click();
  }

  async render_upsell_popup() {
    const popup_content_container = document.querySelector(".upsell-content");
    if (!popup_content_container) return;

    const upsell_products = await this.get_upsell_products_not_in_cart();

    let product_to_render =
      upsell_products[
        this.randomIntFromInterval(0, upsell_products.length - 1)
      ];

    popup_content_container.innerHTML =
      getPopupUpsellTemplate(product_to_render);

    function getPopupUpsellTemplate(product) {
      return `  
      <div class="content__header">
        <h5>Check This Out!</h5>
        <p class="subheader">You're going to look great...</p>
      </div>
      <div class="content__image">
        <img class="RecommendedProduct__img popup" src="${
          product.featured_image
            ? product.featured_image
            : product.images[0].src
        }" alt="${product.title}" />
      </div>
      <div class="content__info">
        <h3 class="product__title">${product.title}</h3>
        <p class="product__price">$${
          product.price
            ? parseFloat(product.price / 100).toFixed(2)
            : product.variants[0].price
        }</p>
        ${
          product.variants.length > 1
            ? `
            <select name="id">
              ${product.variants
                .map((variant) => {
                  return `<option value="${variant.id}" ${
                    variant.available ? "" : "disabled"
                  }>${variant.title}</option>`;
                })
                .join("")}
            </select>
          `
            : ""
        }
        <button class="button button--full" type="button button--full-width">Add to Cart</button>
      </div>
    `;
    }
  }

  add_popup_upsell(e) {
    const _this = this;

    var addData = {
      id: e.target.closest(".content__info").querySelector("[name='id']")
        .value /* for testing, change this to a variant ID on your store */,
      quantity: 1,
    };

    fetch("/cart/add.js", {
      body: JSON.stringify(addData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With":
          "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
      },
      method: "POST",
    })
      .then(function (response) {
        _this.continue_to_sidecart();
      })
      .catch(function (err) {
        /* uh oh, we have error. */
        console.error(err);
      });
  }
  
}